import TimeModel from './time.model';

export default class SceneStatisticsModel {
    uid: string;
    totalTimeWatched: number[];
    time: TimeModel;
}
